import { render, staticRenderFns } from "./item_analytics.vue?vue&type=template&id=7b9963a7&scoped=true&"
import script from "./item_analytics.vue?vue&type=script&lang=js&"
export * from "./item_analytics.vue?vue&type=script&lang=js&"
import style0 from "./item_analytics.vue?vue&type=style&index=0&id=7b9963a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9963a7",
  null
  
)

export default component.exports